var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',{attrs:{"value":_vm.activeTab}},[_c('vs-tab',{attrs:{"label":"Draft"}},[_c('Draft')],1),_c('vs-tab',{attrs:{"label":"Processing"}},[_c('Processing')],1),_c('vs-tab',{attrs:{"label":"Completed"}},[_c('Completed')],1),_c('vs-tab',{attrs:{"label":"Canceled"}},[_c('Canceled')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }